const rolesConfig = [
  {
    name: 'home',
    roles: {
      publisher: 'full',
      chief_editor: 'full',
      editor: 'full',
      writer: 'full',
      proofreader: 'full',
      role_none: 'full',
    },
  },
  {
    name: 'wallet_detail',
    roles: {
      publisher: 'full',
      chief_editor: 'full',
      editor: 'full',
      writer: 'full',
      role_none: 'full',
      proofreader: 'full',
    },
  },
  {
    name: 'wallet_detail_wallet',
    roles: {
      publisher: 'full',
      chief_editor: 'full',
      editor: 'full',
      writer: 'full',
      role_none: 'full',
      proofreader: 'full',
    },
  },
  {
    name: 'wallet_detail_nft',
    roles: {
      publisher: 'full',
      chief_editor: 'full',
      editor: 'full',
      writer: 'full',
      role_none: 'full',
      proofreader: 'full',
    },
  },
  {
    name: 'wallet_detail_summary',
    roles: {
      publisher: 'full',
      chief_editor: 'full',
      editor: 'full',
      writer: 'full',
      role_none: 'full',
      proofreader: 'full',
    },
  },
  {
    name: 'wallet_detail_option',
    roles: {
      publisher: 'full',
      chief_editor: 'full',
      editor: 'full',
      writer: 'full',
      role_none: 'full',
      proofreader: 'full',
    },
  },
  {
    name: 'user_detail',
    roles: {
      publisher: 'full',
      chief_editor: 'full',
      editor: 'full',
      writer: 'full',
      role_none: 'full',
      proofreader: 'full',
    },
  },
  {
    name: 'user_detail_basic',
    roles: {
      publisher: 'full',
      chief_editor: 'full',
      editor: 'full',
      writer: 'full',
      role_none: 'full',
      proofreader: 'full',
    },
  },
  {
    name: 'user_detail_billing',
    roles: {
      publisher: 'full',
      chief_editor: 'full',
      editor: 'full',
      writer: 'full',
      role_none: 'full',
      proofreader: 'full',
    },
  },
  {
    name: 'user_detail_unsubscribe',
    roles: {
      publisher: 'full',
      chief_editor: 'full',
      editor: 'full',
      writer: 'full',
      role_none: 'full',
      proofreader: 'full',
    },
  },
  {
    name: 'user_detail_service',
    roles: {
      publisher: 'full',
      chief_editor: 'full',
      editor: 'full',
      writer: 'full',
      role_none: 'full',
      proofreader: 'full',
    },
  },
  {
    name: 'user_detail_password',
    roles: {
      publisher: 'full',
      chief_editor: 'full',
      editor: 'full',
      writer: 'full',
      role_none: 'full',
      proofreader: 'full',
    },
  },
  {
    name: 'article_list_create',
    roles: {
      publisher: 'full',
      chief_editor: 'full',
      editor: 'full',
      writer: 'full',
      role_none: 'full',
      proofreader: 'full',
    },
  },
  {
    name: 'article_list',
    roles: {
      publisher: 'full',
      chief_editor: 'full',
      editor: 'full',
      writer: 'full',
      role_none: 'full',
      proofreader: 'full',
    },
  },
  {
    name: 'article_trashed_list',
    roles: {
      publisher: 'full',
      chief_editor: 'full',
      editor: 'full',
      writer: 'full',
      role_none: 'full',
      proofreader: 'full',
    },
  },
  {
    name: 'article_detail_body',
    roles: {
      publisher: 'full',
      chief_editor: 'full',
      editor: 'full',
      writer: 'full',
      role_none: 'full',
      proofreader: 'full',
    },
  },
  {
    name: 'article_detail_attr',
    roles: {
      publisher: 'full',
      chief_editor: 'full',
      editor: 'full',
      writer: 'full',
      role_none: 'full',
      proofreader: 'full',
    },
  },
  {
    name: 'article_detail_issue',
    roles: {
      publisher: 'full',
      chief_editor: 'full',
      editor: 'view',
      writer: 'view',
      proofreader: 'view',
    },
  },
  {
    name: 'article_create',
    roles: {
      publisher: 'full',
      chief_editor: 'full',
      editor: 'full',
      writer: 'full',
      role_none: 'full',
      proofreader: 'full',
    },
  },
  {
    name: 'article_published',
    roles: {
      publisher: 'full',
    },
  },
  {
    name: 'article_create_attr',
    roles: {
      publisher: 'full',
      chief_editor: 'full',
      editor: 'full',
      writer: 'full',
      role_none: 'full',
      proofreader: 'full',
    },
  },
  {
    name: 'article_detail',
    roles: {
      publisher: 'full',
      chief_editor: 'full',
      editor: 'full',
      writer: 'full',
      role_none: 'full',
      proofreader: 'full',
    },
  },
  {
    name: 'article_focus',
    roles: {
      publisher: 'full',
      chief_editor: 'full',
      editor: 'full',
      writer: 'full',
      role_none: 'full',
      proofreader: 'full',
    },
  },
  {
    name: 'article_detail_sns',
    roles: { publisher: 'full', chief_editor: 'full', editor: 'view' },
  },
  {
    name: 'folder_detail',
    roles: {
      publisher: 'full',
      chief_editor: 'full',
      editor: 'full',
      writer: 'full',
      role_none: 'full',
      proofreader: 'full',
    },
  },
  {
    name: 'folder_detail_attr',
    roles: {
      publisher: 'full',
      chief_editor: 'full',
      editor: 'full',
      writer: 'full',
      role_none: 'full',
      proofreader: 'full',
    },
  },
  {
    name: 'folder_create',
    roles: {
      publisher: 'full',
      chief_editor: 'full',
      editor: 'full',
      writer: 'full',
      role_none: 'full',
      proofreader: 'full',
    },
  },
  {
    name: 'folder_create_attr',
    roles: {
      publisher: 'full',
      chief_editor: 'full',
      editor: 'full',
      writer: 'full',
      role_none: 'full',
      proofreader: 'full',
    },
  },
  {
    name: 'newsletter_list',
    roles: {
      publisher: 'full',
      chief_editor: 'full',
      role_none: 'full',
      proofreader: 'view',
      editor: 'view',
      writer: 'view',
    },
  },
  {
    name: 'newsletter_detail',
    roles: {
      publisher: 'full',
      chief_editor: 'full',
      proofreader: 'view',
      editor: 'view',
      writer: 'view',
    },
  },
  {
    name: 'newsletter_detail_attr',
    roles: {
      publisher: 'full',
      chief_editor: 'full',
      proofreader: 'view',
      editor: 'view',
      writer: 'view',
    },
  },
  {
    name: 'newsletter_detail_issue',
    roles: {
      publisher: 'full',
      chief_editor: 'full',
      proofreader: 'view',
      editor: 'view',
      writer: 'view',
    },
  },
  {
    name: 'newsletter_detail_member',
    roles: {
      publisher: 'full',
      chief_editor: 'full',
      editor: 'view',
      proofreader: 'view',
      writer: 'view',
    },
  },
  {
    name: 'newsletter_detail_task',
    roles: {
      publisher: 'full',
      chief_editor: 'full',
      editor: 'view',
      proofreader: 'view',
      writer: 'view',
    },
  },
  {
    name: 'newsletter_detail_gantt',
    roles: {
      publisher: 'full',
      chief_editor: 'full',
      editor: 'view',
      writer: 'view',
      proofreader: 'view',
    },
  },
  {
    name: 'newsletter_detail_subscriber',
    roles: {
      publisher: 'full',
      chief_editor: 'full',
      editor: 'view',
      proofreader: 'view',
      writer: 'view',
    },
  },
  {
    name: 'newsletter_create',
    roles: {
      publisher: 'full',
      chief_editor: 'full',
      editor: 'full',
      writer: 'full',
      role_none: 'full',
      proofreader: 'full',
    },
  },
  {
    name: 'issue_create',
    roles: {
      publisher: 'full',
      chief_editor: 'full',
    },
  },
  {
    name: 'issue_create_attr',
    roles: {
      publisher: 'full',
      chief_editor: 'full',
    },
  },
  {
    name: 'issue_detail',
    roles: {
      publisher: 'full',
      chief_editor: 'full',
      editor: 'view',
      writer: 'view',
      proofreader: 'view',
    },
  },
  {
    name: 'issue_detail_attr',
    roles: {
      publisher: 'full',
      chief_editor: 'full',
      editor: 'view',
      writer: 'view',
      proofreader: 'view',
    },
  },
  {
    name: 'issue_detail_article',
    roles: {
      publisher: 'full',
      chief_editor: 'full',
      editor: 'view',
      writer: 'view',
      proofreader: 'view',
    },
  },
  {
    name: 'issue_detail_publish',
    roles: {
      publisher: 'full',
      chief_editor: 'view',
      editor: 'view',
      writer: 'view',
      proofreader: 'view',
    },
  },
  {
    name: 'queue_list',
    roles: {
      publisher: 'full',
      chief_editor: 'full',
      editor: 'view',
      writer: 'view',
      proofreader: 'view',
    },
  },
  {
    name: 'queue_delete',
    roles: {
      publisher: 'full',
      chief_editor: 'full',
    },
  },
  {
    name: 'task_detail',
    roles: {
      publisher: 'full',
      chief_editor: 'full',
      editor: 'view',
      writer: 'view',
      proofreader: 'view',
    },
  },
  {
    name: 'task_detail_attr',
    roles: {
      publisher: 'full',
      chief_editor: 'full',
    },
  },
  {
    name: 'task_create',
    roles: {
      publisher: 'full',
      chief_editor: 'full',
    },
  },
  {
    name: 'task_create_attr',
    roles: {
      publisher: 'full',
      chief_editor: 'full',
    },
  },
  {
    name: 'newsletter_user_detail',
    roles: {
      publisher: 'full',
      chief_editor: 'full',
      writer: 'view',
      editor: 'view',
      proofreader: 'view',
    },
  },
  {
    name: 'newsletter_subscriber_detail',
    roles: {
      publisher: 'full',
      chief_editor: 'full',
      editor: 'view',
      writer: 'view',
      proofreader: 'view',
    },
  },
  {
    name: 'newsletter_subscribe_create',
    roles: {
      publisher: 'full',
      chief_editor: 'full',
    },
  },
  {
    name: 'newsletter_user_detail_basic',
    roles: {
      publisher: 'full',
      chief_editor: 'full',
      editor: 'view',
      writer: 'view',
      proofreader: 'view',
    },
  },
];

export { rolesConfig };
